import { applyMiddleware, combineReducers, legacy_createStore as createStore } from "redux";
import { themColorReducer } from "./reducers/theme";
import thunk from "redux-thunk";
import { menuStatusReducer } from "./reducers/common";
import { languagesReducer } from "./reducers/languages";
import { select } from "./reducers/select";
import { trackReducer } from "./reducers/track";

const rootReducer = combineReducers({
  themeColors: themColorReducer,
  menuStatus:menuStatusReducer,
  languages: languagesReducer,
  select: select,
  trackStatus: trackReducer
});

export const store = createStore(rootReducer, applyMiddleware(thunk));

// In this code, we first import the necessary functions and libraries from redux and redux-thunk.
// Next, we import the themColorReducer, etc from the ./reducers folders, which manages the state of purticular state in the Redux store.
// The rootReducer is then created by combining the themColorReducer with any other possible reducers using the combineReducers function from redux.
// Finally, the Redux store is created using the createStore function from redux and the rootReducer. The applyMiddleware function is used to apply the thunk middleware to the store, allowing for asynchronous actions in the application.
// The store is then exported so that it can be imported and used in other parts of the application.
